// extracted by mini-css-extract-plugin
module.exports = {"root":"RoomBookingCard_root__30Q7_","guests":"RoomBookingCard_guests__3zWmo","name":"RoomBookingCard_name__3QGpc","dates":"RoomBookingCard_dates__1IyEo"};